import { useMemo, useRef, useState } from 'react';
import { Input, Select } from 'antd';

const { Search } = Input;
const { Option } = Select;

//* HOC's
import { withLanguageContext } from 'context';

//* Helpers
import { config, getParamsByKey } from 'helpers';

//* Components
import Icon from 'components/common/Icon';
import Button from 'components/common/Button';
import CustomSelect from 'components/common/FormSelect';

const MediaFilter = ({ categories, types, orders, translate, onCategoryChange, router, queryParamKeys }) => {
	//! Ref
	const searchRef = useRef(null);

	//! States
	const [searchValue, setSearchValue] = useState();
	const [isChanged, setIsChanged] = useState(false);

	//! Default Search Value
	const defaultSearchValue = useMemo(() => {
		const searchParam = queryParamKeys[4]; //? "s"
		const activeItems = getParamsByKey(router, searchParam);

		setSearchValue(activeItems?.[0]);

		return activeItems?.[0];
	}, [router, queryParamKeys]);

	//! Type Value
	const typeValue = useMemo(() => {
		const typeParam = queryParamKeys[0]; //? "type"
		const activeItems = getParamsByKey(router, typeParam);

		return activeItems?.[0] || types[0].id;
	}, [router, queryParamKeys, types]);

	//! Cat value
	const catValue = useMemo(() => {
		const catParam = queryParamKeys[1]; //? "catId"
		const activeItems = getParamsByKey(router, catParam);

		return (activeItems?.[0] && Number(activeItems?.[0])) || '';
	}, [router, queryParamKeys, categories]);

	//! Order value
	const orderValue = useMemo(() => {
		const orderParam = queryParamKeys[2]; //? "orderBy"
		const activeItems = getParamsByKey(router, orderParam);

		return Number(activeItems?.[0]) || orders[0].id;
	}, [router, queryParamKeys, orders]);

	//! Store type options
	const storeTypeOptions = useMemo(() => {
		return types.map((type, index) => (
			<Option
				key={index}
				value={type.id}>
				{type.name}
			</Option>
		));
	}, [types]);

	//! Store category options
	const storeCategoryOptions = useMemo(() => {
		return categories.map((category, index) => (
			<Option
				key={index}
				value={category.id}>
				{category.name}
			</Option>
		));
	}, [categories]);

	//! Store orders options
	const storeOrderOptions = useMemo(() => {
		return orders.map((order, index) => (
			<Option
				key={index}
				value={order.id}>
				{order.name}
			</Option>
		));
	}, [orders]);

	return (
		<div className='col-3 col-ts-12 col-m-12'>
			<div className='media-library-filter-wrap'>
				<div className={`search-field-container ${searchValue && !isChanged ? 'disable-search-button' : ''}`}>
					<Search
						size={'large'}
						ref={searchRef}
						maxLength={512}
						autoCorrect='off'
						autoComplete='off'
						value={searchValue}
						autoCapitalize='off'
						placeholder={translate('search')}
						className={'media-library-search'}
						onChange={(e) => {
							setSearchValue(e.target.value);
							!isChanged && setIsChanged(true);
						}}
						onSearch={(value) => {
							value != defaultSearchValue && onCategoryChange('s', value);
							setIsChanged(false);
						}}
					/>
					<Icon
						name='cancel'
						className='search-clear secondaryColor2'
						onClick={() => {
							setSearchValue('');
							onCategoryChange('s', '');
							if (searchRef.current) {
								searchRef.current.focus();
							}
						}}
					/>
				</div>
				<CustomSelect
					size={'large'}
					value={typeValue}
					className={'media-library-select'}
					suffixIcon={<Icon name={'dropdown'} />}
					onChange={(type) => onCategoryChange('type', type)}>
					{storeTypeOptions}
				</CustomSelect>
				<CustomSelect
					value={catValue}
					className={'media-library-select'}
					size={'large'}
					suffixIcon={<Icon name={'dropdown'} />}
					onChange={(catId) => onCategoryChange('catId', catId)}
					defaultValue={''}>
					<Option value={''}>{translate('allCategories')}</Option>
					{storeCategoryOptions}
				</CustomSelect>
				<CustomSelect
					value={orderValue}
					placeholder={translate('orders')}
					className={'media-library-select'}
					size={'large'}
					suffixIcon={<Icon name={'dropdown'} />}
					onChange={(orderId) => onCategoryChange('orderBy', orderId)}>
					{storeOrderOptions}
				</CustomSelect>
				<Button
					text={'clear'}
					color={'ColorBigStone'}
					hoverColor={'ColorApricot'}
					borderColor={'ColorApricot'}
					hoverBorderColor={'ColorApricot'}
					background={'ColorApricot'}
					hoverBackground={'transparent'}
					className={'media-library-clear'}
					onClick={() => router.push(config.routes.mediaLibrary.path)}
				/>
			</div>
		</div>
	);
};

export default withLanguageContext(MediaFilter, ['translate']);
